import {inject, Pipe, PipeTransform} from '@angular/core';
import {AbilityService} from '../services/ability.service';

@Pipe({
  name: 'customAble',
  standalone: true
})
export class AblePipe implements PipeTransform {
  abilityService = inject(AbilityService);
  ability = this.abilityService.getAbilitiesChecker()
  

  transform(action: string, subject: string): boolean {
    return this.ability.can(action, subject);
  }
}
